import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Typography, Divider, Button } from '@mui/material';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Barlow:wght@300;400;600;700&display=swap');
`;

export default function SmsTerms() {
  const navigate = useNavigate();

  return (
    <>
      <style>{styles}</style>
      <Box sx={{ minHeight: '100vh', background: '#0D1E35' }}>

        {/* Header */}
        <Box sx={{
          background: 'linear-gradient(180deg, #0a1828 0%, #0D1E35 100%)',
          borderBottom: '1px solid rgba(201,168,76,0.15)',
          py: 5, textAlign: 'center',
        }}>
          <Container maxWidth="md">
            <Box sx={{ mb: 3 }}>
              <img src="/horzlogo.png" alt="Torch Beach Volleyball"
                style={{ maxWidth: 280, width: '60vw', objectFit: 'contain' }} />
            </Box>
            <Typography sx={{
              fontFamily: '"Bebas Neue", sans-serif',
              fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
              letterSpacing: 4, color: 'white', lineHeight: 1, mb: 1,
            }}>
              SMS Messaging Program
            </Typography>
            <Box sx={{ width: 60, height: 2, background: 'linear-gradient(90deg, transparent, #C9A84C, transparent)', mx: 'auto', my: 2 }} />
            <Typography sx={{
              color: 'rgba(255,255,255,0.45)', fontFamily: '"Barlow", sans-serif',
              fontWeight: 300, fontSize: '0.9rem', letterSpacing: 0.5,
            }}>
              Terms, Conditions & Opt-In Information
            </Typography>
          </Container>
        </Box>

        {/* Content */}
        <Container maxWidth="md" sx={{ py: 6 }}>
          <Box sx={{
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(201,168,76,0.15)',
            borderRadius: 3, p: { xs: 3, md: 5 },
          }}>

            {/* Program Description */}
            <Section title="Program Description">
              <P>Torch Beach Volleyball ("Torch", "we", "us") operates an SMS messaging program to communicate with registered members, athletes, parents, and coaches. Messages may include class reminders, schedule changes, check-in confirmations, session balance alerts, tournament updates, and important club announcements.</P>
              <P>Sender: Torch Beach Volleyball · +1 (855) 513-5286</P>
            </Section>

            <Sep />

            {/* How to Opt In */}
            <Section title="How to Opt In">
              <P>You may opt in to receive SMS messages from Torch Beach Volleyball in the following ways:</P>
              <ul style={{ color: 'rgba(255,255,255,0.75)', fontFamily: '"Barlow", sans-serif', fontWeight: 300, lineHeight: 1.9, paddingLeft: 20, marginTop: 8 }}>
                <li>During online registration at <strong style={{ color: '#C9A84C' }}>app.torchvolleyball.com/register</strong> by checking the SMS consent checkbox. Registration requires a signed-in account; the consent language and checkbox are reproduced publicly at <a href="/sms-optin" style={{ color: '#C9A84C' }}>app.torchvolleyball.com/sms-optin</a>.</li>
                <li>By texting <strong style={{ color: '#C9A84C' }}>JOIN</strong> to +1 (855) 513-5286</li>
                <li>By contacting us directly at the gym and providing written consent</li>
              </ul>
              <P>By opting in, you confirm that you are the account holder or have authorization to opt in the provided phone number.</P>
            </Section>

            <Sep />

            {/* Message Types & Frequency */}
            <Section title="Message Types & Frequency">
              <P>Message frequency varies based on club activity. Typical message types include:</P>
              <ul style={{ color: 'rgba(255,255,255,0.75)', fontFamily: '"Barlow", sans-serif', fontWeight: 300, lineHeight: 1.9, paddingLeft: 20, marginTop: 8 }}>
                <li>Class reminders and schedule changes</li>
                <li>Check-in confirmations and session balance notifications</li>
                <li>Low session balance alerts</li>
                <li>Tournament registration confirmations and updates</li>
                <li>Important club announcements</li>
              </ul>
              <P>You may receive up to 4–6 messages per month on average, though frequency may increase during active tournament seasons.</P>
            </Section>

            <Sep />

            {/* How to Opt Out */}
            <Section title="How to Opt Out">
              <P>You may opt out of SMS messages at any time by replying <strong style={{ color: '#C9A84C' }}>STOP</strong> to any message you receive from us. After opting out, you will receive one final confirmation message and no further messages will be sent.</P>
              <P>You may also opt out by logging into your account at app.torchvolleyball.com and updating your notification preferences, or by contacting us directly.</P>
            </Section>

            <Sep />

            {/* Help */}
            <Section title="Help">
              <P>For assistance, reply <strong style={{ color: '#C9A84C' }}>HELP</strong> to any message, or contact us at:</P>
              <ul style={{ color: 'rgba(255,255,255,0.75)', fontFamily: '"Barlow", sans-serif', fontWeight: 300, lineHeight: 1.9, paddingLeft: 20, marginTop: 8 }}>
                <li>Email: <strong style={{ color: '#C9A84C' }}>info@torchvolleyball.com</strong></li>
                <li>Website: <strong style={{ color: '#C9A84C' }}>app.torchvolleyball.com</strong></li>
              </ul>
            </Section>

            <Sep />

            {/* Costs */}
            <Section title="Message & Data Rates">
              <P>Message and data rates may apply. Torch Beach Volleyball does not charge for SMS messages, but your mobile carrier's standard messaging and data rates apply. Contact your carrier for details.</P>
            </Section>

            <Sep />

            {/* Privacy */}
            <Section title="Privacy">
              <P>Your phone number and personal information will not be shared with or sold to third parties for marketing purposes. Information collected is used solely for club communications. For full details, please review our <strong style={{ color: '#C9A84C' }}>Privacy Policy</strong>.</P>
              <P>Carriers are not liable for delayed or undelivered messages.</P>
            </Section>

            <Sep />

            {/* Supported Carriers */}
            <Section title="Supported Carriers">
              <P>This program is supported by all major US carriers including AT&T, T-Mobile, Verizon, Sprint, Boost Mobile, US Cellular, and others. Carrier support may vary.</P>
            </Section>

          </Box>

          {/* Footer nav */}
          <Box sx={{ textAlign: 'center', mt: 4 }}>
            <Button variant="outlined" onClick={() => navigate('/')}
              sx={{ borderColor: 'rgba(201,168,76,0.4)', color: '#C9A84C', '&:hover': { borderColor: '#C9A84C', backgroundColor: 'rgba(201,168,76,0.08)' } }}>
              Back to Home
            </Button>
          </Box>

          <Box sx={{ py: 4, textAlign: 'center' }}>
            <Typography sx={{ fontSize: '0.7rem', color: 'rgba(255,255,255,0.18)', letterSpacing: 2, textTransform: 'uppercase', fontFamily: '"Barlow", sans-serif' }}>
              © {new Date().getFullYear()} Torch Beach Volleyball · Geneva, FL · Last updated April 2026
            </Typography>
          </Box>
        </Container>
      </Box>
    </>
  );
}

function Section({ title, children }) {
  return (
    <Box sx={{ mb: 0 }}>
      <Typography sx={{
        fontFamily: '"Bebas Neue", sans-serif',
        fontSize: '1.1rem', letterSpacing: 3, color: '#C9A84C', mb: 1.5,
      }}>
        {title}
      </Typography>
      {children}
    </Box>
  );
}

function P({ children }) {
  return (
    <Typography sx={{
      color: 'rgba(255,255,255,0.75)', fontFamily: '"Barlow", sans-serif',
      fontWeight: 300, lineHeight: 1.9, mb: 1.5, fontSize: '0.95rem',
    }}>
      {children}
    </Typography>
  );
}

function Sep() {
  return <Divider sx={{ my: 3, borderColor: 'rgba(201,168,76,0.1)' }} />;
}
